/**
 * @generated SignedSource<<35e9066ddf547b05a2eb0daf3ade98d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentHeadlineTagContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"hooksContentHeadlineTagContent">;
  readonly " $fragmentType": "contentHeadlineTagContent";
};
export type contentHeadlineTagContent$key = {
  readonly " $data"?: contentHeadlineTagContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentHeadlineTagContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentHeadlineTagContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksContentHeadlineTagContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "cfab9c3509b9d4c49182940ec6d66fbf";

export default node;
